import * as amplitude from '@amplitude/analytics-browser';
import { sendEvent } from './GAEvent';

export const sendAnalyticsEvent = (eventName, properties, category, label) => {
    try {
        amplitude.track(eventName, properties);
        sendEvent(category, eventName, label, properties);
    } catch (e) { }
};